import React, { useCallback, useState, useMemo } from 'react'

import { useTranslation } from 'react-i18next'
import { size, isEmpty } from 'lodash'
import { defaultTableConfigsWithMultiple } from 'pages/Administration/components/Table/configs'
import { rolesColumns } from './config'

import Table from 'pages/Administration/components/Table'
import {
  getSimpleNodeId,
  handleColumnDefs,
  onExportData,
  sendNotification,
  excelStyles,
  sizeTableToFit
} from 'pages/Administration/helpers'
import {
  defaultActions,
  frameworkComponents
} from 'pages/Administration/constants'
import { deleteRole, fetchRole } from 'api/administration/rolesUsersService'
import { useAgGridTranslation } from 'utils/hooks/useDocumentTranslation'
import { openModal } from 'components/Modal/actions'

const RolesPanel = ({ roles }) => {
  const { t, i18n } = useTranslation(['Administration', 'Common'])

  const [gridApi, setGridApi] = useState(null)
  const [columnApi, setColumnApi] = useState(null)

  const handleOpenModal = ({ data, colDef }) => {
    if (colDef.colId === 'name') {
      openModal('administrationRole', {
        roleValue: { ...data },
        modalType: 'UpdateRole',
        roles: roles,
        gridApi: gridApi
      })
    }
  }

  const onDeleteRoleSubmit = async () => {
    for (const element of gridApi?.getSelectedNodes()) {
      try {
        await deleteRole(element.data.id)
        gridApi?.deselectAll()
        sendNotification({
          t,
          info: 'Delete',
          kind: 'success',
          message: t('Administration:RolesManagement.DeletedRole')
        })
      } catch (err) {
        console.error('error', err)
      }
    }
    await fetchRole()
  }

  const onDeleteRole = () => {
    openModal('confirmAction', {
      modalHeading: t('Administration:RolesManagement.DeleteRole'),
      message: t('Common:RoleDeletionConfirmation'),
      onConfirm: onDeleteRoleSubmit,
      loadingOverlay: true
    })
  }

  const handleAddRole = () => {
    openModal('administrationRole', {
      modalType: 'AddRole',
      roles: roles,
      gridApi: gridApi
    })
  }

  const headerActions = useMemo(() => {
    if (!isEmpty(gridApi)) {
      return {
        selected: [
          {
            id: 'deleteRole',
            title: t('Administration:RolesManagement.Actions.Delete'),
            handleClick: () => {
              onDeleteRole()
            }
          }
        ],
        empty: [
          {
            id: 'exportRole',
            title: t('Administration:RolesManagement.Actions.ExportAll'),
            handleClick: () => {
              gridApi &&
                columnApi &&
                onExportData(
                  gridApi,
                  columnApi,
                  t('Administration:RolesManagement.Title')
                )
            }
          },
          {
            id: 'addRole',
            title: t('Administration:RolesManagement.Actions.InsertNewRole'),
            handleClick: handleAddRole
          }
        ]
      }
    }
    return defaultActions
  }, [t, gridApi, onDeleteRole, onExportData, handleAddRole])

  const { t: agGridT, destroyed } = useAgGridTranslation()

  return (
    <div>
      {/*<h2 className='no-action-view'>*/}
      {/*  {t('Administration:RolesManagement.Title')}*/}
      {/*</h2>*/}
      <Table
        headerActions={headerActions}
        columnDefs={handleColumnDefs(rolesColumns, t)}
        rowData={size(roles) ? roles : []}
        getRowNodeId={getSimpleNodeId}
        onCellClicked={handleOpenModal}
        excelStyles={excelStyles}
        onGridReady={({ api, columnApi }) => {
          setGridApi(api)
          setColumnApi(columnApi)
          sizeTableToFit(api)
        }}
        frameworkComponents={frameworkComponents}
        defaultTableConfigs={defaultTableConfigsWithMultiple}
        key={i18n.language}
        localeTextFunc={agGridT}
      />
    </div>
  )
}

export default React.memo(RolesPanel)
